import React, { Component } from "react";
import { Link } from "react-router-dom";
import "./styles/Footer.css";
import logo from "../images/logo.png";
import {
  FaLinkedin,
  FaFacebookF,
  FaYoutube,
  FaTwitter,
  FaInstagram,
} from "react-icons/fa";

export class Footer extends Component {
  render() {
    return (
      <div>
        <footer className="footer">
          <div className="container">
            <div className="row">
              <div className="col-md-5">
                <div className="footer-widget__about ">
                  <div className="footer-widget__logo">
                    <img src={logo} alt="AtEase Logo" />
                  </div>
                  <div className="footer-widget__about-text-box">
                    <p className="footer-widget__about-text">
                      AtEase Insurance is an online insurance company focused
                      on providing insurance cover to freelancers and startups!
                      We understand the peculiarities of the pay models for
                      individuals in the techspace and are committed to
                      providing seamless transparent and affordable insurance
                      services!
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-md-2">
                <div className="footer-widget__column footer-widget__explore clearfix">
                  <ul className="footer-widget__explore-list footer-widget__explore-list-two clearfix">
                    <li>
                      <Link to="/contact">CONTACT US</Link>
                    </li>
                    <li>
                      <Link to="/about">ABOUT US</Link>
                    </li>
                    <li>
                      <Link to="#">SITEMAP</Link>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-md-2">
                <div className="footer-widget__column footer-widget__explore clearfix">
                  <ul className="footer-widget__explore-list footer-widget__explore-list-two  clearfix">
                    <li>
                      <Link to="/contact">FAQs</Link>
                    </li>
                    <li>
                      <Link to="#">PRIVACY POLICY</Link>
                    </li>
                    <li>
                      <Link to="#">INVESTOR PORTAL</Link>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-md-3">
                <div className="footer-widget__column footer-widget__explore clearfix">
                  <ul className="footer-widget__explore-list footer-widget__explore-list-two  clearfix">
                    <li>
                      <Link to="#">RELATED LINKS</Link>
                    </li>
                    <li>
                      <Link to="#">TERMS AND CONDITIONS</Link>
                    </li>
                    <li>
                      <Link to="#">INFORMATION SECURITY POLICY</Link>
                    </li>
                  </ul>
                </div>

                <div className="site-footer__social ">
                  <Link to="#">
                    <FaLinkedin />
                  </Link>
                  <Link to="#">
                    <FaFacebookF />
                  </Link>
                  <Link to="#">
                    <FaYoutube />
                  </Link>
                  <Link to="#">
                    <FaTwitter />
                  </Link>
                  <Link to="#">
                    <FaInstagram />
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </footer>
        <div className="site-footer__bottom">
          <div className="container">
            <div className="row">
              <div className="col-xl-12">
                <div className="site-footer__bottom-inner">
                  <p className="site-footer__bottom-text">
                    © 2022 AtEase Insurance | All Rights Reserved
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Footer;
